import { palette } from "../lib/finance";

const initials = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Deterministic per-payee color, stable across renders and sessions without storing one.
const colorFor = (id: string) => {
  let hash = 0;
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return palette[hash % palette.length];
};

export default function PayeeAvatar({ id, name, size = 40 }: { id: string; name: string; size?: number }) {
  return (
    <span
      className="payee-avatar"
      style={{ width: size, height: size, background: colorFor(id), fontSize: size * 0.36 }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
